import { useContext } from 'react'
import { useSelector } from 'react-redux'

import { GiftIcon, TicketIcon, MedalIcon } from '@phosphor-icons/react'

import routes from 'core/routes'

import { BtnCard } from 'modules/console/components'

import { ThemeContext } from 'providers/theme'

import { TRootReducer } from 'store'

import {
  CardIntro,
  CardMenu,
  CountUp,
  CountUpEmpty,
  Score,
  ScoreLabel,
} from './styles'

function HomeView() {
  const { app, user } = useSelector((state: TRootReducer) => state)
  const { theme } = useContext(ThemeContext)

  return (
    <>
      <CardIntro
        background={theme.colors.primary}
        color={theme.colors.foreground}
      >
        <Score>
          {typeof user.scores === 'undefined' ? (
            <CountUpEmpty>...</CountUpEmpty>
          ) : (
            <CountUp start={0} end={user.scores} duration={5} />
          )}
          <ScoreLabel>
            {`ponto${user.attributes.total_scores || 0 > 1 ? 's' : ''}`}
          </ScoreLabel>
        </Score>
      </CardIntro>

      <CardMenu>
        <BtnCard
          to={`/${app.key + routes.app.console.scores}`}
          icon={<MedalIcon size={29} />}
          label="Extrato de Pontos"
          description="Acompanhe seus pontos e saiba quando vão expirar."
        />

        <BtnCard
          to={`/${app.key + routes.app.console.rewards}`}
          icon={<GiftIcon size={29} />}
          label="Recompensas"
          description="Veja quais recompensas já estão disponíveis para resgate."
        />
        <BtnCard
          to={`/${app.key + routes.app.console.sweepstakes}`}
          icon={<TicketIcon size={24} />}
          label="Sorteios"
          description="Acompanhe os sorteios disponíveis e seus números da sorte."
        />
      </CardMenu>
    </>
  )
}

export { HomeView }
